module.exports = __webpack_public_path__ + "img/ic_liveness_0.dc16b8f0.png";